import AppService from '../../../services/axios_services'

import {
  SET_USER_DATA,
  ALL_SELLPOINTS,
  ALL_SELLPOINTS_SUCCESS,
  USER_SELLPOINTS,
  USER_SELLPOINT,
  USER_SELLPOINT_APP_SUB_OFFERS,
  USER_SELLPOINT_SHIPPING,
  USER_SELLPOINT_DISCOUNTS,
  USER_SELLPOINT_CATEGORIES,
  USER_SELLPOINT_CATEGORY,
  USER_SELLPOINT_CATEGORY_PRODUCTS,
  USER_SELLPOINT_PRODUCTS,
  USER_SELLPOINT_PRODUCT,
  ALL_PRODUCTS,
  ALL_PRODUCTS_SUCCESS,
  SET_SELLPOINT_CATEGORIES,
  //
  RESET_SELLPOINTS

} from './../../mutation-types'

//
let service = new AppService();

//user
export const accountUserActions = {
    setUserData({commit},id) {
        //commit(SET_USER_DATA)
        let payload = {};
        service.getUser(id).then(function(response) {
            if(response.data.status == 200) {
                payload = response.data.data;
                payload.user_id = id;
                commit(SET_USER_DATA, payload)
            }
        }).catch((err) => {})
    }, // -> dispatch('account/setUserData')
}

//sellpoint
export const accountSellpointActions = {
  
  userAccountBusinesses ({commit},id) {
    //commit(USER_SELLPOINTS)
    service.getBusinesses(id).then(function(response) {
      commit(USER_SELLPOINTS, response.data.data)
    }).catch((err) => {})
  }, // -> dispatch('account/userAccountBusinesses')

  userAccountBusiness({commit},payload) {
    commit(USER_SELLPOINT,payload)
  },

    setBusiness({commit},payload) {
        //clear prev
        commit(RESET_SELLPOINTS);
        //commit new
        commit(USER_SELLPOINT, payload);
        //get business from server
        // service.getAppBusinessByUserName(payload.username).then(function(response) {
        //     commit(USER_SELLPOINT, response.data.data);
        //     if(payload.redir && (payload.redir != '')){
        //         location.replace(payload.redir);
        //     }
        // }).catch((err) => {})
    },
 

  setSellpointAppSubscriptionOffers({commit},payload) {
    commit(USER_SELLPOINT_APP_SUB_OFFERS,payload)
  },
  setBusinessShipping({commit},payload) {
    commit(USER_SELLPOINT_SHIPPING,payload)
  },
  setBusinessDiscounts({commit},payload) {
    commit(USER_SELLPOINT_DISCOUNTS,payload)
  },

}

//categories
export const accountCategoryActions = {
  
    setBusinessCategories ({commit,getters}) {
        const business = getters['getUserBusiness'];
        const id = business.business_id;
        if(id > 0){
            service.getBusinessCategories(id).then(function(response) {
                commit(USER_SELLPOINT_CATEGORIES, response.data.data)
            }).catch((err) => {})
        }
    }, // -> dispatch('account/setBusinessCategories')

    setSellpointCategories({commit},payload) {
        commit(USER_SELLPOINT_CATEGORIES,payload)
        //also commit for...
        commit(SET_SELLPOINT_CATEGORIES,payload)
    }, // -> dispatch('account/setSellpointCategories')
    
    setCategory({commit},payload) {
        commit(USER_SELLPOINT_CATEGORY,payload)
    }
}

//product
export const accountProductActions = {
  
    setBusinessProducts ({commit},payload) {
        commit(USER_SELLPOINT_PRODUCTS, payload);
    }, // -> dispatch('account/setBusinessProducts')

    setBusinessProductsDEPRAC ({commit,getters}) {
        const xsellpoint = getters['getUserBusiness'];
        const sellpoint_id = xsellpoint.business_id;
        if(sellpoint_id > 0){
            service.getAppBusinessProducts(sellpoint_id,100).then(function(response) {
                commit(USER_SELLPOINT_PRODUCTS, response.data.data)
            }).catch((err) => {})
        }
    }, // -> dispatch('account/userAccountBusinesses')
    
    setBusinessCategoryProducts ({commit},payload) {
        commit(USER_SELLPOINT_CATEGORY_PRODUCTS, payload);
    }, // -> dispatch('account/setCategoryProducts')


    setCategoryProductsDEPRAC({commit,getters}) {
        const category = getters['getCategory'];
        const id = category.business_category_id;
        if(id > 0){
            service.getCategoryProducts(id).then(function(response) {
                commit(USER_SELLPOINT_PRODUCTS, response.data.data)
            }).catch((err) => {})
        }
    }, 

    setProduct({commit},payload) {
        commit(USER_SELLPOINT_PRODUCT,payload)
    },
    
}






// WEBPACK FOOTER //
// ./src/store/modules/account/actions.js